module.exports = __webpack_public_path__ + "img/preview_pdf.496cfc97.png";